module.exports = __webpack_public_path__ + "static/media/logo-vodovod-rijeka.99b44162.png";